@let testIdPrefix = 'active-qr-code-list';
<app-bottom-sheet-wrapper
    [title]="headerTitle()"
    [titleAlignment]="titleAlignment()"
    [class]="bottomSheetClass()"
    [readonlyStepper]="headerStepper()"
    (onClose)="onClose()"
>
    @switch (step()) {
        @case (stepper.ActiveQrList) {
            <app-qr-code-list
                (onStepChange)="onStepChange()"
                (onAddQrClicked)="onGoToGenerateQR()"
            ></app-qr-code-list>
        }
        @case (stepper.ViewQRDetails) {
            <app-review-qr-details
                [actions]="qrCodeDetailsActions()"
                [testIdPrefix]="testIdPrefix"
                [isReadOnly]="true"
            ></app-review-qr-details>
        }
        @case (stepper.GenerateQR) {
            <app-qr-onboarding-stepper
                (onCloseClientStepper)="onClose()"
                (confirmCloseStepper)="onClose()"
                (onClientStepChange)="onStepChange()"
                (onClientBackChange)="onBackToActiveQrList()"
                (onQrHeaderIndexChange)="onQrIndexHeaderChange($event)"
            ></app-qr-onboarding-stepper>
        }
    }
</app-bottom-sheet-wrapper>
